import { render, staticRenderFns } from "./InternationalAirFareCap.vue?vue&type=template&id=853d9644&"
import script from "./InternationalAirFareCap.vue?vue&type=script&lang=js&"
export * from "./InternationalAirFareCap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports